import { useProposalVotes } from '@/queries/governance'
import { VoteOption } from '@/types/governance'

interface ProposalVoteCountsProps {
  proposalId: string
}

export default function ProposalVoteCounts({
  proposalId,
}: ProposalVoteCountsProps) {
  const { data: votesData } = useProposalVotes(proposalId, { limit: '1000' })

  if (!votesData?.votes) {
    return (
      <>
        <div className='flex min-w-30 flex-col gap-1 text-sm'>
          <span className='text-muted-foreground'>YES:</span>
          <span className='text-foreground'>—</span>
        </div>
        <div className='flex min-w-30 flex-col gap-1 text-sm'>
          <span className='text-muted-foreground'>NO:</span>
          <span className='text-foreground'>—</span>
        </div>
      </>
    )
  }

  // We intentionally don't use voting power and fetch votes directly to get accurate counts
  const yesCount = votesData.votes.filter(vote =>
    vote.options.some(opt => opt.option === VoteOption.Yes),
  ).length

  const noCount = votesData.votes.filter(vote =>
    vote.options.some(opt => opt.option === VoteOption.No),
  ).length

  return (
    <>
      <div className='flex min-w-30 flex-col gap-1 text-sm'>
        <span className='text-muted-foreground'>YES:</span>
        <span className='text-foreground'>{yesCount}</span>
      </div>
      <div className='flex min-w-30 flex-col gap-1 text-sm'>
        <span className='text-muted-foreground'>NO:</span>
        <span className='text-foreground'>{noCount}</span>
      </div>
    </>
  )
}
